import React from 'react'


export default function CardProfile({ nama, jabatan, hp, email, profileImage,onClick }) {
  return (
    <div
      className="flex cursor-pointer flex-col xl:w-[30%] space-y-2 justify-center items-center cardProfile shadow-lg border border-borderCardFeatures bg-white py-[53px] px-12 rounded-2xl"
      onClick={onClick}
    >
      <div className="rounded-full photo">
        <img
          crossOrigin="anonymous"
          src={profileImage}
          alt="gambar profile"
          width={286.95}
          height={286.95}
          className="w-64 h-64 rounded-full"
        />
      </div>
      <h2 className="block text-2xl font-semibold text-center text-nameColor">{nama}</h2>
      <div className="label rounded-2xl bg-hoverColor px-4 py-[10px]">
        <span className="block font-bold text-nameColor">{jabatan}</span>
      </div>
      <h3 className="text-base font-bold text-phoneColor">{hp}</h3>
      <h3 className="text-base font-bold text-phoneColor">{email}</h3>
    </div>
  );
}
